import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import {pageTitle} from '../../../../configuration/configuration';
import { SessionHelper } from '../../../shared/services/localstorage';
import {LoginService} from '../../../../globalservices/login.service';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})

export class HeaderComponent implements OnInit {
  userObj : any;
  pageTitle:string = ""
  // profileUrl='assets/img/user-profile.png';
  profileUrl='assets/icons/ico-view-profile.svg';
  
  constructor(
    public router: Router,
    public dialog:MatDialog,
    private loginService:LoginService) { }

  ngOnInit() {
    this.loginService.currentProfile.subscribe((profileUrl:any)=>{
      this.profileUrl=localStorage.getItem('profileUrl');
      })
    // this.pageTitle=pageTitle.Dashboard;
    this.loginService.currentPageTitle.subscribe((updatedTitle:any)=>{
      if(updatedTitle!=''&& updatedTitle!=null && updatedTitle!=undefined){
        this.pageTitle=updatedTitle;
      }
    
      console.log("pageTitle123",this.pageTitle);
    })
 
 
    this.setUserDetails();
    // this.speakerServ.pageTitle.subscribe(updatedTitle => {
    //   this.pageTitle = updatedTitle;
    // });
  }
  onChangePassword(){
    console.log("onChangePassword");
  this.router.navigate(['changepassword']);
    // let dialogRef = this.dialog.open(ChangepasswordComponent, {
    //   height: '400px',
    //   width: '600px',
    // });
    // dialogRef.afterClosed().subscribe(result => {
    //   console.log(`Dialog result: ${result}`); // Pizza!
    // });
  }
  onLogoutClick(){
    // this.logOut
     this.loginService.changeStatus(false);
    SessionHelper.logout();
    this.router.navigate(['']);

    // this.loginService.logOut('')
    // .subscribe((result:any)=>{
    //   console.log("result logOut",result);
    // })
    // this.service.getData("/logout", null).then((resData: any) => {
    //   if (resData.status == "success") {
    //     SessionHelper.logout();
    //     this.router.navigate(['/auth/login']);
    //   }
    // });
  }

  setUserDetails(){
    this.userObj = SessionHelper.getSession();
    console.log("this.userObj123",this.userObj );
  }

}



